import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
const PdpEligibilityContext = createContext({
    isProductEligibleForV2: false,
    setIsProductEligibleForV2: () => { },
});
PdpEligibilityContext.displayName = 'PdpEligibility';
export const PdpEligibilityProvider = ({ children }) => {
    const [isProductEligibleForV2, setIsProductEligibleForV2] = useState(false);
    const value = useMemo(() => ({ isProductEligibleForV2, setIsProductEligibleForV2 }), [isProductEligibleForV2]);
    return _jsx(PdpEligibilityContext.Provider, { value: value, children: children });
};
export const usePdpEligibility = () => useContext(PdpEligibilityContext);
